import { Box } from '@mui/material';
import styled from 'styled-components';

export const HomeHeader = styled(Box)`
  && {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: ${({ theme }) => theme.spacing(7)};
  }
`;
